import { BaseModel } from "./common.model";
import { EcosystemServiceModel } from "./ecosystem-service.model";
import { ExerciseModel } from "./exercise.model";

//Contiene los valores de cada ecosystema por servicio
export interface ExerciseEcoserviceEcosystemModel extends BaseModel {
  ecosystem: { id: string, name: string; area: number };
  status: 'draft' | 'disable' | 'enable';
  exercise: ExerciseModel.Ref;
  ecoservice: { id: string; pos: number } //Rferencia del servicio ecosystema
  valuationMethodId: string;
  // assets:Array<Asset>;

}

//i:indicator, m:monetary
export interface Asset {
  id?: string;
  name: string;
  area: number;
  iHa: number;
  index0: number;
  index1: number;
  sourceI: string;
  totalI: number;
  mPer: number;  //money per indicator or area
  sourceM: string;
  totalValue: number;
}

export namespace ExerciseEcoserviceEcosystemModel {
  export const create = (exercise: ExerciseModel, ecoservice: Partial<EcosystemServiceModel>, ecosystem) => {
    return {
      ecosystem: { id: ecosystem.id, name: ecosystem.name, area: ecosystem.area },
      status: 'draft',
      exercise: ExerciseModel.genRef(exercise),
      ecoservice: { id: ecoservice.id, pos: ecoservice.pos }, //Rferencia del servicio ecosystema
      valuationMethodId: (ecoservice.valuationMethods && ecoservice.valuationMethods.length) ? ecoservice.valuationMethods[0].id : null,
    }
  }
}





//Ejemplo
const assetsValue: ExerciseEcoserviceEcosystemModel =
{
  ecosystem: { id: "", name: "", area: 0 },
  status: 'draft',
  valuationMethodId: '',
  exercise: null,
  ecoservice: null,
  // assets:[
  //   {
  //     id:'',
  //     name:'',
  //     area:0,
  //     iHa:0,
  //     index0:1,
  //     index1:1,
  //     sourceI:'',
  //     totalI:0,
  //     mPer: 0,  //money per indicator or area
  //     sourceM:'',
  //     totalValue:0
  //   }
  // ]

}

